import { RadioExportDestinationModal } from './RadioExportDestinationModal';

export type Platform = 'Radio';
interface Props {
  modalContext: {
    exportTargetId: string;
    exportTargetTypeId: string;
    platform?: Platform;
  };
}

const platforms = {
  Radio: RadioExportDestinationModal // add tv exports here when refactor to new modal?
};

export const BroadcastExportModal = (props: Props) => {
  const { modalContext } = props;
  const { platform } = modalContext;

  const Component = platforms[platform];
  return Component ? <Component {...props} /> : null;
};
